import { createSlice } from "@reduxjs/toolkit"
import { RootState } from "integrations/redux"

type SatelliteOverlapState = {
    visibleByFlightId: Record<string, boolean>
    hoveredSceneIdByFlightId: Record<string, string | undefined>
}

const initialState: SatelliteOverlapState = {
    visibleByFlightId: {},
    hoveredSceneIdByFlightId: {},
}

export const satelliteOverlapSliceName = "satellite-overlap-ui-v1" as const

export const {
    reducer: SatelliteOverlapReducer,
    actions: { setSatelliteOverlapVisibility, setSatelliteHoveredSceneId },
} = createSlice({
    name: satelliteOverlapSliceName,
    initialState,
    reducers: {
        setSatelliteOverlapVisibility: (
            state,
            action: { payload: { id: string; active?: boolean } }
        ) => {
            const { id, active } = action.payload
            if (active === undefined) {
                delete state.visibleByFlightId[id]
            } else {
                state.visibleByFlightId[id] = active
            }
        },
        setSatelliteHoveredSceneId: (
            state,
            action: { payload: { id: string; sceneId: string | undefined } }
        ) => {
            state.hoveredSceneIdByFlightId[action.payload.id] = action.payload.sceneId
        },
    },
})

const root = (s: RootState) => s[satelliteOverlapSliceName] as SatelliteOverlapState

export const selectSatelliteOverlapIsVisible = (id: string) => (s: RootState) =>
    root(s).visibleByFlightId[id] as boolean | undefined

export const selectSatelliteHoveredSceneId = (id: string) => (s: RootState) =>
    root(s).hoveredSceneIdByFlightId[id]
